import { useDataAttributes } from '@data-attributes/use-data-attributes';
import { Checkbox } from '@eika/checkbox';
import { useInputs } from '@hooks/use-inputs';
import { useTranslation } from '@translations';

export const CompareWithSavingsAccountCheckbox = () => {
    const { compareWithSavingsAccount, setCompareWithSavingsAccount } = useInputs();
    const { inputs } = useTranslation();
    const { compareWithSavingsAccountCheckboxDataAttrs } = useDataAttributes();

    return (
        <Checkbox
            onValueChange={(checked) => {
                setCompareWithSavingsAccount(checked);
            }}
            checked={compareWithSavingsAccount}
            label={inputs.compareWithSavingsAccountCheckbox}
            {...compareWithSavingsAccountCheckboxDataAttrs}
        />
    );
};
